import ListItemIcon from '@core/components/Menu/ListItemIcon';
import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import { Button, IconButton, makeStyles, Tooltip } from '@material-ui/core';
import { relatorioApi } from 'app/services/api/relatorioApi';
import { eventReactGA } from 'app/utils/analyticsUtil';
import { visualizarRelatorioV2 } from 'app/utils/enviromentUtil';
import React, { useContext } from 'react';
import { FaArrowAltCircleUp, FaBarcode, FaChartBar } from 'react-icons/fa';
import { ContaReceberContext } from '../contaReceberContext';
import { contaReceberModais } from './modal/contaReceberModais';

const searchHeaderContaReceberStyles = makeStyles({
  searchBarContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    maxWidth: '512px',
  },
  link: {
    color: '#53c4e6',
    fontWeight: '600',
    textTransform: 'none',
  },
  buttonChartContainer: {
    color: 'white',
    backgroundColor: 'rgba(88, 144, 170, 0.8)',
    '&:hover': {
      backgroundColor: 'rgba(88, 144, 170, 1)',
      boxShadow: 'none',
      borderColor: 'rgba(88, 144, 170, 0)',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: 'rgba(88, 144, 170, 0.9)',
      borderColor: 'rgba(88, 144, 170, 0)',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(88, 144, 170,0.9)',
      borderColor: 'rgba(88, 144, 170, 0)',
    },
  },
  buttonIconBoleto: {
    marginRight: '20px',
  },
});

const ContaReceberSearchHeader = ({ fetchContasReceber, onGerarRemessa, onEnviarCobrancasEmail }) => {
  const [search, setSearch] = useContext(ContaReceberContext).search;
  const [, setModal] = useContext(ContaReceberContext).modal;
  const [selecao] = useContext(ContaReceberContext).selecao;
  const [filtroAvancado] = useContext(ContaReceberContext).filtroAvancado;
  const [tipoSelecao] = useContext(ContaReceberContext).tipoSelecao;
  const [somatorios] = useContext(ContaReceberContext).somatorios;

  /*
RNE-341 - Comportamento do comando "Enviar cobrança(s) por e-mail"
O usuário poderá enviar cobranças por e-mail apenas para contas abertas, desde que estejam com remessa gerada. Portanto, o comando "Enviar cobrança(s) por e-mail" não será exibido nas ações da cobrança quando a situação selecionada no filtro for igual a "Baixada" ou "Excluída".

Quando o usuário selecionar alguns registros no resultado da pesquisa e acionar o comando "Enviar cobrança(s) por e-mail", o sistema deve considerar as cobranças das contas abertas e enviar e-mail para os clientes correspondentes, considerando o e-mail cadastrado.

Observação: O assunto do e-mail deve ser: #lt;Nome da  empresa#gt; - Cobrança #lt;DD/MM/AAAA#gt;
Onde DD/MM/AAAA é a data de vencimento da cobrança.

Exemplo: Casa Design - Cobrança 10/02/2018

Quando o usuário selecionar pelo menos uma conta a receber aberta que não teve remessa gerada e/ou conta excluída e/ou conta baixada, o sistema exibe o comando desabilitado com a mensagem [MSG-142] em um hint.
   */
  const selecaoPossuiBoleto =
    (tipoSelecao === 'TODOS_FILTRO' && somatorios.quantidadeBoleto > 0) ||
    selecao.some((selecionado) => selecionado.tipoCobranca === 'BOLETO' || selecionado.tipoCobranca === 'PARTNER_BANK');

  const selecaoPossuiBoletoSemRemessaGerada = !!somatorios?.quantidadeSelecionadasRemessaNaoGerada;

  // const selecaoPossuiPix =
  //   somatorios.quantidadeSelecionadasPix > 0 || (tipoSelecao === 'TODOS_FILTRO' && somatorios.quantidadePix > 0);

  const styles = searchHeaderContaReceberStyles();

  const handleOpenBuscaAvancada = () => {
    setModal(contaReceberModais.buscaAvancada);
  };

  const handleOpenGraficos = () => {
    setModal(contaReceberModais.indicadores);
  };

  const handleOpenHistoricoRemessa = () => {
    eventReactGA('Conta a receber', 'Histórico de remessa dos boletos');
    setModal(contaReceberModais.historicoRemessa);
  };

  const handleOpenProcessarArquivoRetorno = () => {
    setModal(contaReceberModais.arquivoRetorno);
  };

  const handleVisualizarBoletos = async () => {
    // const ids = [];
    // if (tipoSelecao === 'TODOS_FILTRO') {
    //   filtro = {
    //     ...filtroAvancado,
    //     ids: selecao?.map((cr) => cr?.id),
    //     query: search,
    //     tipoSelecao,
    //     tiposCobrancas: ['BOLETO', 'PARTNER_BANK'],
    //   };

    // const response = await boletoApi.buscarUuidsCobranca(filtro);
    // ids = response.data;
    // } else {
    // ids = selecao
    //   ?.filter((cr) => cr.tipoCobranca === 'BOLETO' || cr.tipoCobranca === 'PARTNER_BANK')
    //   .map((cr) => cr.uuidBoleto);
    // }

    const filtro = {
      ...filtroAvancado,
      ids: selecao?.map((cr) => cr?.id),
      query: search,
      tipoSelecao,
      tiposCobrancas: ['BOLETO', 'PARTNER_BANK'],
    };

    eventReactGA('Conta a receber', 'Visualizar boletos');
    const response = await relatorioApi().salvarFiltroBoleto(filtro);
    visualizarRelatorioV2(response.data);
    // visualizarRelatorio(ids, 'conta-receber/boleto', 'titulo=boleto', 'protegerComSenha=false');
  };

  return (
    <PageHeader
      title="Contas a receber"
      icon={<FaArrowAltCircleUp />}
      button={
        <>
          <ListItemIcon
            icon={<FaBarcode className="stepAcoesBoleto" />}
            title="Exibir ações do boleto"
            customStyles={styles.buttonIconBoleto}
            listItem={[
              {
                title: 'Enviar cobrança(s) por e-mail',
                onClick: () =>
                  onEnviarCobrancasEmail({
                    ids: selecao?.map((contaReceber) => contaReceber?.id),
                    tipoSelecao,
                    q: '',
                    tipoFiltro: 'SIMPLES',
                    ...filtroAvancado,
                  }),
                disabled: selecaoPossuiBoletoSemRemessaGerada || !selecaoPossuiBoleto,
                hint: selecaoPossuiBoletoSemRemessaGerada
                  ? 'Existem cobranças selecionadas que não podem ser enviadas por e-mail porque não tiveram remessa gerada ou estão baixadas ou excluídas.'
                  : undefined,
                // RNE-341 [...]o comando "Enviar cobrança(s) por e-mail" não será exibido nas ações da cobrança quando a situação selecionada no filtro for igual a "Baixada" ou "Excluída".[...]
                hide:
                  filtroAvancado?.situacao === 'BAIXADA' ||
                  filtroAvancado?.situacao === 'EXCLUIDA' ||
                  filtroAvancado?.situacao === 'PARCIAL',
              },
              {
                title: 'Gerar remessa dos boletos',
                onClick: () => onGerarRemessa(),
                hint:
                  'Selecione as contas abertas que deseja gerar o arquivo remessa e acione o comando. As contas alteradas e/ou baixadas serão enviadas automaticamente na remessa seguinte.',
              },
              // { title: 'Gerar remessa do pix' },
              { title: 'Processar arquivo retorno dos boletos', onClick: handleOpenProcessarArquivoRetorno },
              // { title: 'Processar arquivo retorno do Pix' },
              {
                title: 'Histórico de remessa dos boletos',
                onClick: () => handleOpenHistoricoRemessa(),
              },
              // { title: 'Histórico de remessa do Pix' },
              {
                title: 'Visualizar boletos',
                onClick: handleVisualizarBoletos,
                disabled: !selecaoPossuiBoleto,
                hint: !selecaoPossuiBoleto ? 'As cobranças selecionadas não possuem boleto.' : undefined,
              },
              // {
              //   title: 'Visualizar cobranças Pix',
              //   disabled: !selecaoPossuiPix,
              //   hint: !selecaoPossuiPix ? 'As cobranças selecionadas não possuem Pix.' : undefined,
              // },
            ]}
          />

          <Tooltip title="Exibir indicadores">
            <IconButton className={styles.buttonChartContainer} onClick={handleOpenGraficos}>
              <FaChartBar className="stepVisualizarDashboards" />
            </IconButton>
          </Tooltip>
        </>
      }
    >
      <div className={styles.searchBarContainer}>
        <div className="flex items-center w-full max-w-512 stepBarraPesquisa">
          <SearchBar searchText={search} onChange={setSearch} />
        </div>
        <div className="stepBuscaAvancada">
          <Button className={styles.link} onClick={handleOpenBuscaAvancada}>
            Busca avançada
          </Button>
        </div>
      </div>
    </PageHeader>
  );
};

export default ContaReceberSearchHeader;
